module.exports = __webpack_public_path__ + "img/gegame.799ed2d.webp";